//import "preact/debug";
import React from 'react';
import ReactDOM from 'react-dom';
import App from '../react/components/genus-product-configurator/genus-product-configurator.jsx';



export default class GenusProductConfigurator {
    constructor() {
        this.container = document.querySelector('#js-genus-product-configurator');

        if (this.container) {
            const id = this.container.dataset.id;
            const title = this.container.dataset.title;
            ReactDOM.render(
                <React.StrictMode>
                    <App nodeId={id} title={title} />
                </React.StrictMode >,
                this.container
            );
        }
    }
}

window.GenusProductConfigurator = function () {
    ReactDOM.render(<App />, document.getElementById('js-genus-product-configurator'));
    return this;
}